import type { IconType } from 'react-icons';
import type { AppManifest } from '@api/apps';
import { iconFor } from './appIcons';

/** How an app appears in the gallery; everything else is its page. */
export interface AppPresentation {
  readonly icon: IconType;
  readonly cover: string | null;
  readonly coverLight: string | null;
}

export const presentationOf = (manifest: AppManifest | null | undefined): AppPresentation => {
  const spec = manifest?.presentation ?? {};
  return {
    icon: iconFor(spec.icon),
    cover: spec.cover ?? null,
    coverLight: spec.coverLight ?? null,
  };
};
